<template>
	<div style="padding: 10px;">
		<el-row :gutter="20">
			<el-col :span="6"> 
				<el-input clearable placeholder="ObjectID" v-model="searchInfo.name">
					<template slot="prepend">ObjectID</template>
				</el-input>
			</el-col>
			<el-col :span="12"> 
				<div style="min-width: 300px;">
					<el-button type="primary" @click="searchCalcPoint" icon="el-icon-search">搜索</el-button>
					<el-button  icon="el-icon-refresh" @click="clearSearch">重置</el-button>
					<el-button type="primary" icon="el-icon-plus" @click="addCalc">新增</el-button>
					<el-button type="primary" icon="el-icon-plus" @click="autoshow = true">自动添加</el-button>
				</div>
			</el-col>
		</el-row>
		<div style="margin-top: 10px;">
			<el-table :data="sysCalcList"  style="width: 100%"  max-height="700">
			    <el-table-column fixed="left" prop="name" label="点位名称" width="150" align="center"></el-table-column>
			    <el-table-column prop="objectid" label="ObjectID" align="center"></el-table-column>
				<el-table-column prop="propertyid" label="属性id" align="center"></el-table-column>
				<el-table-column prop="idx" label="排序" align="center"></el-table-column>
				<el-table-column prop="func" label="计算公式" width="300" align="center"></el-table-column>
				<el-table-column prop="unit" label="单位"  align="center"></el-table-column>
				<el-table-column prop="defaultshow" label="默认显示"  align="center">
					<template slot-scope="scope">
						<el-tag v-if="'Y' == scope.row.defaultshow" type="success">显示</el-tag>
						<el-tag v-else  type="info" >不显示</el-tag>
					</template>
				</el-table-column>
				<el-table-column fixed="right" prop="op" label="操作" width="220" align="center">
					<template slot-scope="scope">
						<a @click="goSysConfigDetail(scope.$index, scope.row)" title="详情" style="display:inline-block;cursor:pointer;color: #409EFF;">
							<i class="el-icon-Stall">详情</i>
						</a>
						<a @click="deleteDetail(scope.$index, scope.row)" title="删除" style="display:inline-block;cursor:pointer;color: #F56C6C;margin-left: 20px;">
							<i class="el-icon-Stall">删除</i>
						</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="text-align: center;">
			<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
				:page-size="param.pagenum" :total="calcPointTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
		</div>
		<el-dialog @close="refrashData" :destroy-on-close="true" :title="detailTitle" width="70%" :visible.sync="detailShow">
			<CalcDetail @needRefrash="needRefrash" :add="isadd" :selectedcalc="selectset"></CalcDetail>
		</el-dialog> 
		<el-dialog @close="refrashData" :destroy-on-close="true" title="自动添加校区计算点位" width="60%" :visible.sync="autoshow">
			<div >
				<el-row :gutter="20">
					<el-col :span="6"> 
						<el-select style="width: 100%;" filterable clearable  v-model="autodata.orgid" placeholder="请选择校区">
							<el-option v-for="item in orgList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
						</el-select>
					</el-col>
					<el-col :span="6">
						<el-input type="number" clearable placeholder="校区面积" v-model="autodata.area">
							<template slot="prepend">校区面积</template>
						</el-input>
					</el-col>
					<el-col :span="6">
						<el-input type="number" clearable placeholder="教室数量" v-model="autodata.roomnum">
							<template slot="prepend">教室数量</template>
						</el-input>
					</el-col>
					<el-col :span="6">
						<div style="min-width: 100px;">
							<el-button type="primary" icon="el-icon-plus" @click="autoAddCalc">确认添加</el-button>
						</div>
					</el-col>
				</el-row>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	//import dayjs from 'dayjs'
	import { queryCalcPointsByPage, deleteCalcPoint, autoCreateOrgCacl,queryAllOrg } from '/static/apiUrl.js'
	import CalcDetail from './calcdetail'
	export default {
		name : 'CalcPointList',
		data() {
			return {
				detailShow: false,
				editok : false,
				isadd : false,
				detailTitle: '控制点详情',
				selectset: null,	
				searchInfo:{
					name: '',
					id : '',
				},
				param : {
					page : 1,
					pagenum : 10,
				},
				calcPointTotal : 0,
				sysCalcList : [],
				autoshow : false,
				orgList : [],
				autodata : {
					orgid : '',
					area : 0,
					roomnum : 0
				}
			}
		},
		mounted() {
			this.initData()
			this.queryCalcList()
		},
		components: {
			CalcDetail,
		},
		methods: {
			handleSizeChange(val){
				this.param.pagenum = val;
				this.queryCalcList()
			},
			handleCurrentChange(val){
				this.param.page = val
				this.queryCalcList()
			},
			initData() {
				this.orgList = []
				queryAllOrg().then(res => {
					if(0 == res.code){
						res.datas.forEach((org) => {
							if("XQ" == org.type){
								this.orgList.push(org)
							}
						})
					}
				})
			},
			searchCalcPoint(){
				this.param.page = 1
				this.sysCalcList = []
				this.queryCalcList()
			},
			clearSearch(){
				this.searchInfo.name = ''
				this.param.page = 1
				this.queryCalcList()
			},
			queryCalcList(){
				this.sysCalcList = []
				queryCalcPointsByPage({
					name : this.searchInfo.name,
					pagenum : this.param.page ,
					pagesize : this.param.pagenum
				}).then(res => {
					//console.log(res)
					if(0 == res.code){
						this.calcPointTotal = res.datas.totalnum
						res.datas.data.forEach((set) => {
							this.sysCalcList.push(set)
						})
					}
				})
			},
			goSysConfigDetail(idx,row){
				this.detailTitle = '计算点位详情'
				this.isadd = false
				this.selectset = JSON.parse(JSON.stringify(this.sysCalcList[idx]))
				this.detailShow = true
			},
			deleteDetail(idx,row){
				this.$confirm('此操作将删除计算点位 '+this.sysCalcList[idx].name+', 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteCalcPoint({
						id : this.sysCalcList[idx].id
					}).then(res => {
						if(0 == res.code){
							this.queryCalcList()
							this.$message({
								showClose: true,
								message: "删除成功",
								type: 'success'
							});
						}else{
							this.$message({
								showClose: true,
								message: res.message,
								type: 'error'
							});
						}
					})
				}).catch(() => {
					console.log("取消")
				});
			},
			addCalc(){
				this.detailTitle = "新增计算点位"
				this.isadd = true
				this.selectset = null
				this.detailShow = true
			},
			autoAddCalc(){
				this.$confirm('确认是否自动添加校区计算点位?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					autoCreateOrgCacl({
						oid : this.autodata.orgid,
						area : this.autodata.area,
						room : this.autodata.roomnum
					}).then(res => {
						if(0 == res.code){
							this.queryCalcList()
							this.$message({
								showClose: true,
								message: "自动添加成功",
								type: 'success'
							});
						}else{
							this.$message({
								showClose: true,
								message: "添加计算点位异常",
								type: 'error'
							});
						}
					})
				})
			},
			needRefrash(val,isshow){
				this.editok = val
				this.detailShow = isshow
			},
			refrashData() {
				if(this.editok){
					this.queryCalcList()
				}
			}
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>